// extracted by mini-css-extract-plugin
export default {"mainTitle":"css_mainTitle__YNtFy","subTitle":"css_subTitle__7Ytpa"};